var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"base"},[_c('v-progress-circular',{attrs:{"size":_vm.mySize,"width":_vm.width,"color":_vm.color,"value":_vm.valor}}),_c('span',{staticClass:"primary--text font-weight-bold posicionar",class:_vm.esMovil ? 'movil' : 'normal'},[_vm._v(" "+_vm._s(this.putuacionVista)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }